<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">Confirm Submission</h5>
  </div>

  <div class="modal-body text-center">
    @if(isconfirm){
    <div class="icon-container mb-3">⚠️</div>

    <p class="main-text">Are you sure you want to submit this evaluation?</p>

    <p class="sub-text">Once submitted, you cannot edit scores or Remark.</p>

    } @else if(isSubmiting){
    <div class="d-flex justify-content-center">
      <mat-spinner
        diameter="50"
        strokeWidth="4"
        class="custom-spinner"
      ></mat-spinner>
    </div>

    <p class="mt-3 main-text">Submitting your evaluation...</p>

    <p class="sub-text">Please wait, do not close or refresh the page.</p>
    } @else{

    <div class="success-icon mb-3">
      <i class="fa-solid fa-circle-check blue"></i>
    </div>

    <h5 class="mb-2">Evaluation Submitted Successfully</h5>

    <p class="sub-text">Your evaluation has been recorded.</p>

    <div class="countdown mt-3">
      Redirecting to Candidate List... in
      <span class="count-number">{{ countdown }}</span>
    </div>

    }
  </div>

  @if(isconfirm){
  <div class="modal-footer justify-content-center">
    <button
      (click)="Submit()"
      type="button"
      class="btn btn-primary"
      data-dismiss="modal"
    >
      Submit Evaluation
    </button>
    <button
      (click)="cancel()()"
      type="button"
      class="btn btn-cancel"
      data-dismiss="modal"
    >
      Cancel
    </button>
    <!--           
        <button
          type="button"
          class="btn btn-outline-secondary px-4"
          data-bs-dismiss="modal"
        >
          Cancel
        </button>

        <button type="button" class="btn btn-primary px-4">
          Submit Evaluation
        </button> -->
  </div>
  }
</div>
